import React from 'react';
import { Loader2, Brain, Clock } from 'lucide-react';

interface GenerationButtonsProps {
  isGenerating: boolean;
  childName: string;
  onCancel: () => void;
  onGenerate: () => void;
}

export function GenerationButtons({
  isGenerating,
  childName,
  onCancel,
  onGenerate
}: GenerationButtonsProps) {
  return (
    <>
      <div className="flex space-x-4 pt-4">
        {!isGenerating && (
          <button
            onClick={onCancel}
            className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 font-semibold transition-colors"
          >
            Cancel
          </button>
        )}
        <button
          onClick={onGenerate}
          disabled={isGenerating}
          className={`${isGenerating ? 'w-full' : 'flex-1'} flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-purple-500 to-blue-600 text-white rounded-xl hover:opacity-90 font-semibold transition-opacity disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          {isGenerating ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              <span>AI is thinking...</span>
            </>
          ) : (
            <>
              <Brain className="w-5 h-5" />
              <span>Generate with AI</span>
            </>
          )}
        </button>
      </div>

      {/* Generation Time Estimate */}
      {isGenerating && (
        <div className="text-center text-sm text-gray-600 bg-blue-50 rounded-lg p-3">
          <Clock className="w-4 h-4 inline mr-2" />
          AI is creating a personalized activity for {childName}. This may take 15-30 seconds.
        </div>
      )}
    </>
  );
}
